import StudentQuizzes from "layouts/StudentQuizzes";
import QuizByCode from "layouts/QuizByCode";
import Titles from "layouts/titles";
import ShowTile from "layouts/titles/ShowTile";
import ShowThreeD from "layouts/titles/ShowThreeD";
import ShowQuestions from "layouts/quizTitles/ShowQuestions";
import Icon from "@mui/material/Icon";

const studentRoutes = [
  {
    type: "collapse",
    name: "Histology",
    key: "histology",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/histology",
    component: <Titles type="his" readOnly />,
  },
  {
    type: "collapse",
    name: "Embryology",
    key: "embryology",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/embryologyTitles",
    component: <Titles type="emb" readOnly />,
  },
  {
    type: "collapse",
    name: "3D Models",
    key: "threeD",
    icon: <Icon fontSize="small">view_in_ar</Icon>,
    route: "/threeDTitles",
    component: <Titles type="three_d_model" readOnly />,
  },
  {
    type: "collapse",
    name: "Quiz by code",
    key: "quiz-by-code",
    icon: <Icon fontSize="small">quiz</Icon>,
    route: "/quiz-by-code",
    component: <QuizByCode />,
  },
  {
    type: "collapse",
    name: "My Quizzes",
    key: "my-quizzes",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/my-quizzes",
    component: <StudentQuizzes />,
  },
  {
    name: "showTitle",
    key: "showTitle",
    route: "/showTitle/:id/:lang",
    component: <ShowTile />,
  },
  {
    name: "showThreeD",
    key: "showThreeD",
    route: "/showThreeD/:id/:lang",
    component: <ShowThreeD />,
  },
  {
    name: "showQuestions",
    key: "showQuestions",
    route: "/showQuestions/:id/:lang",
    component: <ShowQuestions />,
  },
];

export default studentRoutes;
